export const formatSingleTime12Hour = (timeStr) => {
  if (!timeStr) return "";
  const trimmed = String(timeStr).trim();
  if (/AM|PM/i.test(trimmed)) return trimmed;
  const match = trimmed.match(/^(\d{1,2})(?::(\d{2}))?(?::(\d{2}))?$/);
  if (match) {
    let h = parseInt(match[1], 10);
    const m = match[2] || "00";
    const ampm = h >= 12 ? "PM" : "AM";
    const h12 = h % 12 || 12;
    return `${h12}:${m} ${ampm}`;
  }
  const [hours, minutes] = trimmed.split(":");
  if (hours !== undefined && minutes !== undefined) {
    const h = parseInt(hours, 10);
    if (!isNaN(h)) {
      const ampm = h >= 12 ? "PM" : "AM";
      const h12 = h % 12 || 12;
      const cleanM = minutes.slice(0, 2);
      return `${h12}:${cleanM} ${ampm}`;
    }
  }
  return trimmed;
};

export const formatTime12Hour = (timeStr) => {
  if (!timeStr) return "";
  const str = String(timeStr).trim();
  if (/\s*(?:to|-)\s*/i.test(str)) {
    const isTo = /\s+to\s+/i.test(str);
    const separator = isTo ? " to " : " - ";
    const parts = str.split(/\s*(?:to|-)\s*/i);
    if (parts.length === 2) {
      return `${formatSingleTime12Hour(parts[0])}${separator}${formatSingleTime12Hour(parts[1])}`;
    }
  }
  return formatSingleTime12Hour(str);
};

export const formatTimeRange = (fromTime, toTime) => {
  if (fromTime && toTime) {
    return `${formatSingleTime12Hour(fromTime)} to ${formatSingleTime12Hour(toTime)}`;
  }
  if (fromTime) return formatSingleTime12Hour(fromTime);
  if (toTime) return formatSingleTime12Hour(toTime);
  return "";
};

export const getDateInputValue = (dateStr) => {
  if (!dateStr) return "";
  return String(dateStr).split("T")[0];
};

export const getTimeInputValue = (dateStr, timeStr) => {
  if (timeStr) {
    const str = String(timeStr).trim();
    let firstPart = str;
    if (/\s*(?:to|-)\s*/i.test(str)) {
      firstPart = str.split(/\s*(?:to|-)\s*/i)[0].trim();
    }
    if (/^\d{2}:\d{2}$/.test(firstPart)) return firstPart;
    if (/^\d{1}:\d{2}$/.test(firstPart)) return `0${firstPart}`;
    const match = firstPart.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
    if (match) {
      let h = parseInt(match[1], 10);
      const m = match[2];
      const ampm = match[3] ? match[3].toUpperCase() : null;
      if (ampm === "PM" && h !== 12) h += 12;
      if (ampm === "AM" && h === 12) h = 0;
      return `${String(h).padStart(2, "0")}:${m}`;
    }
    return firstPart.slice(0, 5);
  }
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("en-GB");
};

export const formatPaidAmount = (amount) => {
  if (amount === null || amount === undefined || amount === "") return "-";
  return `${amount}MUR`;
};

export const formatDisplayDateTime = (dateStr, timeStr) => {
  const datePart = formatDisplayDate(dateStr);
  if (timeStr) {
    return `${datePart} at ${formatTime12Hour(timeStr)}`;
  }
  const d = new Date(dateStr);
  if (!isNaN(d.getTime())) {
    const timePart = d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${datePart} ${timePart}`;
  }
  return datePart;
};
